import { AI_API_SERVICE } from '@eggplant/api-hosts'
import { AuthenticatedPolling } from '@eggplant/data-request'
import type { GetTestConfigTaskDetailsResponse } from '@eggplant/types'
import type { ReactElement } from 'react'

interface Props {
  id: string
  isPoll: boolean
  interval?: number
  onSuccess: (data: GetTestConfigTaskDetailsResponse) => void
  children?: (data: GetTestConfigTaskDetailsResponse) => ReactElement
}

const PollAiTestConfigTaskDetailsRequest = ({
  id,
  isPoll,
  interval = 5000,
  onSuccess,
  children
}: Props) => {
  const url = `${AI_API_SERVICE}/testconfigtasks/${id}/details`

  return (
    <AuthenticatedPolling<GetTestConfigTaskDetailsResponse>
      children={children}
      intervalMs={interval}
      isPolling={isPoll}
      onSuccess={onSuccess}
      url={url}
    />
  )
}

export default PollAiTestConfigTaskDetailsRequest
